import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import CustomFilterSelector from '@shared/components/filters/custom-filter-selector/custom-filter-selector.vue';
import ExtendedFilter from '@shared/components/filters/extended-filter/extended-filter.vue';

@Component({
  name: 'bpc-access-control-event-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
    'bpc-custom-filter-selector': CustomFilterSelector,
    'bpc-extended-filter': ExtendedFilter,
  },
})
export default class AccessControlEventTable extends mixins(AbstractTable) {
  @Prop({ type: Boolean, default: true }) readonly showFilters: boolean;
  @Prop({ type: Boolean, default: true }) readonly showCustomFilters: boolean;
  @Prop({ type: Boolean, default: false }) readonly noCheckBoxColumn: boolean;
  @Prop({ type: String, default: 'default' }) readonly filterConfigName: string;
  @Prop({ type: String, default: 'table' }) readonly displayConfigName: string;
  @Prop({ type: Boolean, default: false }) readonly ignoreURLParams: boolean;

  // public entity: Discount = null;
  public entityName = 'access-control-event';
  public pluralEntityName = 'access-control-events';
  public permissionEntityNameToUse = 'access_control_events';

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  onShow(e) {
    this.onEdit(e, true);
  }
}
